













import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class Uploader extends Vue {
  @Prop({ default: false }) private readonly!: boolean
  @Prop({ default: '' }) private error!: string

  private onClick() {
    ;(this.$refs.file as HTMLInputElement).click()
  }

  @Emit('change')
  private emitChange(files: File[]) {
    return files
  }

  private onChange(e: Event) {
    const input = e.target as HTMLInputElement
    const files = Array.from(input.files || [])
    this.emitChange(files)
    input.value = ''
  }
}
